import { SnapToolsComponent } from 'src/app/components/attribute-view/snap-tools/snap-tools.component';
import { MapComponent } from '../../components/map/map.component';
import { ActionMap } from '../../services/action-handler.service';
import { SLVApp } from '../../types/@types/sl-v-types';
import { SLContext } from '../../types/sl-context';

export class SnapActions {
  private static app: SLVApp;
  private static components: any = {};
  public static SetApp(app) {
    SnapActions.app = app;
  }
  public static RegisterComponent(name: string, component: any) {
    SnapActions.components[name] = component;
  }
  public static Exec(command: string, map: MapComponent, data: any) {
    const commandParts = command.split('-');
    let exec = '';
    commandParts.every((val) => {
      exec += val[0].toUpperCase() + val.substring(1).toLowerCase();
      return true;
    })
    if (SnapActions[exec]) {
      SnapActions[exec](map, data[0]);
    }
  }
  public static RegisterActions(actions: ActionMap): ActionMap {

    actions['snap-actions/move-sel-to-snap'] = {
      name: 'Move selected vertex to snap geometry',
      handler: (context: SLContext, ...args: any) => {
        SnapActions.Exec('move-sel-to-snap', context.map.component, args);
      }
    }
    actions['snap-actions/add-at-snap'] = {
      name: 'Add vertex at snap geometry',
      handler: (context: SLContext, ...args: any) => {
        SnapActions.Exec('add-at-snap', context.map.component, args);
      }
    }
    actions['vertex-actions/move-to-perp'] = {
      name: 'Move selected vertex perpendicularly',
      handler: (context: SLContext, ...args: any) => {
        SnapActions.Exec('move-to-perp', context.map.component, args);
      }
    }
    actions['vertex-actions/add-at-perp'] = {
      name: 'Add selected vertex perpendicularly.',
      handler: (context: SLContext, ...args: any) => {
        SnapActions.Exec('add-at-perp', context.map.component, args);
      }
    }
    actions['snap-actions/merge-snaps'] = {
      name: 'Select and merge snap-geometries into current geometry',
      handler: (context: SLContext, ...args: any) => {
        SnapActions.Exec('merge-snaps', context.map.component, args);
      }
    }
    actions['snap-actions/snap-tools'] = {
      name: 'Snap Tools',
      handler: (context: SLContext, ...args: any) => {
        SnapActions.Exec('snap-tools', context.map.component, args);
      }
    }
    actions['snap-actions/snap-sels-add'] = {
      name: 'Add snap-geometry to selection',
      handler: (context: SLContext, ...args: any) => {
        SnapActions.Exec('snap-sels-add', context.map.component, args);
      }
    }
    actions['snap-actions/snap-sels-del'] = {
      name: 'Remove snap-geometry from selection',
      handler: (context: SLContext, ...args: any) => {
        SnapActions.Exec('snap-sels-del', context.map.component, args);
      }
    }
    actions['snap-actions/snap-sels-grp-add'] = {
      name: 'Box-add snap-geometry to selection',
      handler: (context: SLContext, ...args: any) => {
        SnapActions.Exec('snap-sels-grp-add', context.map.component, args);
      }
    }
    actions['snap-actions/snap-sels-grp-del'] = {
      name: 'Box-remove snap-geometry from selection',
      handler: (context: SLContext, ...args: any) => {
        SnapActions.Exec('snap-sels-grp-del', context.map.component, args);
      }
    }
    return actions;
  }
  private static GetSnapTools(): undefined | SnapToolsComponent {
    if (!SnapActions.components['snap-tools']) return;
    return SnapActions.components['snap-tools'] as SnapToolsComponent;
  }
  private static SetSnapTool(name: string, isOn: boolean) {
    const tools = this.GetSnapTools();
    tools?.SetSnapTool(name, isOn);
  }
  private static SetMergeMode(mode:string,isOn:boolean) {
    const tools = this.GetSnapTools();
    tools?.SetMergeMode(mode,isOn)
  }
  public static MoveSelToSnap(_map, data) {
    const params = data[0];
    const isOn = !!data[0]?.toggled;
    SnapActions.SetSnapTool('move-sel-to-snap', isOn);
  }
  public static AddAtSnap(_map, data) {
    const params = data[0];
    const isOn = !!data[0]?.toggled;
    SnapActions.SetSnapTool('add-at-snap', isOn);
  }
  public static MoveToPerp(_map,data) {
    const params = data[0];
    const isOn = !!data[0]?.toggled;
    SnapActions.SetSnapTool('move-to-perp',isOn);
  }
  public static AddAtPerp(_map, data) {
    const params = data[0];
    const isOn = !!data[0]?.toggled;
    SnapActions.SetSnapTool('add-at-perp', isOn);
  }
  public static MergeSnaps(_map, data) {
    const params = data[0];
    const isOn = !!data[0]?.toggled;
    SnapActions.SetSnapTool('merge-snaps', isOn);
  }
  public static SnapSelsAdd(_map, data) {
    const params = data[0];
    const isOn = !!data[0]?.toggled;
    SnapActions.SetMergeMode('sels-add',isOn);
  }
  public static SnapSelsDel(_map, data) {
    const params = data[0];
    const isOn = !!data[0]?.toggled;
    SnapActions.SetMergeMode('sels-del',isOn);
  }

  public static SnapSelsGrpAdd(_map, data) {
    const params = data[0];
    const isOn = !!data[0]?.toggled;
    SnapActions.SetMergeMode('sels-grp-add',isOn);
  }
  public static SnapSelsGrpDel(_map, data) {
    const params = data[0];
    const isOn = !!data[0]?.toggled;
    SnapActions.SetMergeMode('sels-grp-del',isOn);
  }

}
